

export class QuotePermission {
  public static  CREATE_QUOTE = "CREATE_QUOTE";
  public static UPDATE_QUOTE = "CREATE_QUOTE";
  public static READ_QUOTE = "READ_QUOTE";
}